/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdStructuralTemplateCanvasTemplateProps,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateResult,
} from "./types";

export const postEngagementAppGroupIdStructuralTemplateCanvasTemplate = reactQueryMutationAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateCacheKeys,
  (
    props: PostEngagementAppGroupIdStructuralTemplateCanvasTemplateProps
  ): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateResult> => {
    return fetch(`/engagement/${props.appGroupId}/structural_template/canvas_template`, "POST", props);
  }
);
